import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import type { TagSetResource } from "@octopusdeploy/octopus-server-client";
import pluralize from "pluralize";
import Tag from "~/components/Tag";
import { Summary } from "~/components/form";
export const tagSummaryByIds = (tagSets: TagSetResource[], selectedTags: string[], limit = 3) => tagSummary(tagSets, selectedTags, "ids", limit);
export const tagSummaryByNames = (tagSets: TagSetResource[], selectedTags: string[], limit = 3) => tagSummary(tagSets, selectedTags, "names", limit);
const tagSummary = (tagSets: TagSetResource[], selectedTags: string[], mode: "names" | "ids", limit: number) => {
    if (selectedTags.length === 0) {
        return Summary.summary("No tags selected");
    }
    const hydratedTags = mode === "names" ? hydrateTagsByName(tagSets, selectedTags) : hydrateTagsById(tagSets, selectedTags);
    if (hydratedTags.length === 0) {
        // Fallback in case no tags could be hydrated
        return Summary.summary(`${selectedTags.length} ${pluralize("tag", selectedTags.length)} selected`);
    }
    const tagsToDisplay = hydratedTags
        .filter((item) => item !== null)
        .toSorted((a, b) => {
        if (a.tagSet.Name === b.tagSet.Name) {
            return a.tag.SortOrder - b.tag.SortOrder;
        }
        return a.tagSet.SortOrder - b.tagSet.SortOrder;
    })
        .toSpliced(limit); // Truncate to the limit
    return Summary.summary(<span className={summaryStyles.container}>
            {tagsToDisplay.map(({ tag }) => (<Tag key={tag.Id} tagName={tag.Name} description={tag.Description} tagColor={tag.Color}/>))}
            {selectedTags.length > tagsToDisplay.length && <span className={summaryStyles.moreTags}>+ {hydratedTags.length - limit} more</span>}
        </span>);
};
export const hydrateTagsByName = (tagSets: TagSetResource[], selectedTagNames: string[]) => selectedTagNames.map((canonicalTagName) => {
    const [tagSetName, tagName] = canonicalTagName.split("/");
    const tagSet = tagSets.find((ts) => ts.Name === tagSetName);
    if (!tagSet)
        return null;
    const tag = tagSet.Tags.find((t) => t.CanonicalTagName === canonicalTagName);
    if (tag)
        return { tagSet, tag };
    // Handle free text tags
    return {
        tagSet,
        tag: {
            Id: `${tagSet.Id}/${tagName}`,
            Name: tagName,
            CanonicalTagName: canonicalTagName,
            Color: "#333333",
            Description: "",
            SortOrder: 0,
        },
    };
});
const hydrateTagsById = (tagSets: TagSetResource[], selectedTagIds: string[]) => selectedTagIds.map((tagId) => {
    const [tagSetId, tagPartialId] = tagId.split("/");
    const tagSet = tagSets.find((ts) => ts.Id === tagSetId);
    if (!tagSet)
        return null;
    const tag = tagSet.Tags.find((t) => t.Id === tagId);
    if (tag)
        return { tagSet, tag };
    // Handle free text tags
    return {
        tagSet,
        tag: {
            Id: tagId,
            Name: tagPartialId,
            CanonicalTagName: `${tagSet.Name}/${tagPartialId}`,
            Color: "#333333",
            Description: "",
            SortOrder: 0,
        },
    };
});
const summaryStyles = {
    container: css({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    }),
    moreTags: css({
        margin: space[4],
    }),
};
